/* app/js/src/components/media-transcoder/jobs/jobs.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  width: 100%;
}
.flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.flex .row {
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
}
.flex .column {
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
}
.flex .space-between {
  justify-content: space-between;
}
.flex .to-end {
  justify-content: flex-end;
}
.jobs {
  display: flex;
  flex-direction: column;
  min-height: available;
  margin-top: 40px;
  margin-left: 15px;
  margin-right: 25px;
  margin-bottom: 40px;
}
.jobs nav a {
  display: block;
  height: 36px;
  line-height: 36px;
  font-weight: bold;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  color: #b9bec9;
  text-decoration: none;
  width: 130px;
  border-bottom: 2px solid #f1f3f4;
}
.jobs nav a.active {
  background-color: #f1f3f4 !important;
  border-bottom: 2px solid #40c4ff;
  color: #232f3a;
}
.jobs nav a:hover {
  background-color: #f5f9fd;
}
.jobs nav a:focus {
  outline: none;
}
.jobs .inner-content {
  margin-top: 0.5vw;
}
.jobs .btn-cta {
  background-color: #f5f9fd !important;
  width: auto !important;
  padding-left: 1vw;
  padding-right: 1vw;
  font-size: 16px !important;
  line-height: 30px !important;
  border-bottom: 0 !important;
  margin-left: 1vw;
}
.jobs .btn-cta:hover {
  background-color: #f1f3f4 !important;
}
.jobs .btn-cta .icon {
  color: #40c4ff !important;
}
/*# sourceMappingURL=jobs.component.css.map */
